import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { rememberIntendedPath } from "@/lib/auth-redirect";

export const Route = createFileRoute("/_authenticated")({
  ssr: false,
  staticData: { sitemap: "exclude-subtree" },
  beforeLoad: async ({ location }) => {
    const { supabase } = await import("@/integrations/supabase/client");
    const { data, error } = await supabase.auth.getUser();
    if (error || !data.user) {
      rememberIntendedPath(location.pathname);
      throw redirect({ to: "/auth" });
    }

    // Accept an open invitation first (idempotent). No profile afterwards = no access.
    await supabase.rpc("accept_invitation");
    const { data: profile } = await supabase
      .from("user_profiles")
      .select("actief")
      .eq("user_id", data.user.id)
      .maybeSingle();
    if (!profile) {
      await supabase.auth.signOut();
      throw redirect({ to: "/auth", search: { reden: "geen-toegang" } });
    }
    if (profile.actief === false) {
      await supabase.auth.signOut();
      throw redirect({ to: "/auth", search: { reden: "ingetrokken" } });
    }

    return { user: data.user };
  },
  component: () => <Outlet />,
});
